
import {useTranslation} from 'react-i18next'
import { useMobileDetection } from "../hook/useMobileDetection"

export const Experiencias = () => {  
  const isMobile = useMobileDetection
  const { t } = useTranslation()

  
  const BANNER_SRC = `/image/experiencias/EXBANNER${isMobile()?"_MOBILE":"2"}.webp`
   

  return (
    <div>
      <div className='hero-container'>
        <img src={BANNER_SRC} alt='banner' className='hero-bg' />
        <div className='hero-title'>
          <h1>{t("experiencias_hero")}</h1>
          <span>{t("experiencias_hero_sub")}</span>
        </div>
      </div>
      <div className='container pt-5 pb-5'>
        <div className='pb-5 text-center'>
          <h3>{t("experiencias_cabecera")}</h3>
        </div>
        <div className="image-grid">
          <div className="grid-card">
            <div className="image-wrapper" style={{ "--custom-background": "var(--color-secundario)" }}>
              <img src="/image/experiencias/algarrobina.webp" alt="Algarrobina" loading="lazy" />
            </div>
            <div className="info-overlay">
              <h3>Algarrobina</h3>
              <div className="info-divider"></div>
              <ul style={{ lineHeight: "1" }}>
                <li>60 ml Pisco Altos de Azpitia</li>
                <li>90 ml leche entera fresca</li>
                <li>1 cda extracto de algarrobina</li>
                <li>2 cda jarabe de goma</li>
                <li>1/2 yema de huevo</li>
                <li>4 cubos de hielo</li>
                <li>1 rama de canela entera (para decorar)</li>
              </ul>
              <p className='text-start'>
                <strong>Cristalería:</strong> Copa Huracán.<br />
                <strong>Método:</strong> Licuado.<br />
                <strong>Preparación:</strong> Colocar todos los ingredientes junto con el hielo en una licuadora. Licuar a velocidad media hasta que la mezcla quede completamente uniforme y adquiera una textura cremosa. Servir en la copa huracán y decorar con la rama de canela.
              </p>
            </div>
          </div>

          <div className="grid-card">
            <div className="image-wrapper" style={{ "--custom-background": "var(--color-primario)" }}>
              <img src="/image/experiencias/capitan.webp" alt="Capitan" loading="lazy" />
            </div>
            <div className="info-overlay">
              <h3>Capitán</h3>
              <div className="info-divider"></div>
              <ul style={{ lineHeight: "1" }}>
                <li>2 oz pisco acholado</li>
                <li>1 oz vermouth rosso</li>
                <li>3 gotas amargo de angostura</li>
                <li>6 cubos de hielo</li>
                <li>1 cherry</li>
              </ul>
              <p className='text-start'>
                <strong>Cristalería:</strong> Copa martini bien fría.<br />
                <strong>Método:</strong> Refrescado (Vaso mezclador).<br />
                <strong>Preparación:</strong> Refrescar los ingredientes con hielo en un vaso mezclador por 20 segundos y colar en la copa fría. Decorar con el cherry.
              </p>
            </div>
          </div>

          <div className="grid-card">
            <div className="image-wrapper" style={{ "--custom-background": "var(--color-extraordinario)" }} >
              <img src="/image/experiencias/chilcano de maracuyá.webp" alt="Chilcano de maracuyá" loading="lazy" />
            </div>
            <div className="info-overlay">
              <h3>Chilcano de Maracuyá</h3>
              <div className="info-divider"></div>
              <ul style={{ lineHeight: "1" }}>
                <li>2 oz pisco</li>
                <li>6 cubos de hielo</li>
                <li>1 1/2 oz pulpa de maracuyá</li>
                <li>Completar con Evervess</li>
              </ul>
              <p className='text-start'>
                <strong>Cristalería:</strong> Vaso highball (largo).<br />
                <strong>Método:</strong> Directo.<br />
                <strong>Preparación:</strong> En un vaso highball, agregar el pisco, la pulpa de maracuyá y los cubos de hielo. Completar con Evervess y remover suavemente para integrar. Decorar con una rodaja de limón y una ramita de romero.
              </p>
            </div>
          </div>

          <div className="grid-card">
            <div className="image-wrapper" style={{ "--custom-background": "var(--color-primario)" }} >
              <img src="/image/experiencias/chilcano-frutos-rojos.webp" alt="Chilcano de Frutos Rojos" loading="lazy" />
            </div>
            <div className="info-overlay">
              <h3>Chilcano de Frutos Rojos</h3>
              <div className="info-divider"></div>
              <ul style={{ lineHeight: "1" }}>
                <li>2 oz infusión de frutos rojos en pisco</li>
                <li>7 cubos de hielo</li>
                <li>1/2 oz jugo de limón</li>
                <li>1/2 oz puré de frutos rojos</li>
                <li>4 oz Ginger ale</li>
                <li>3 frambuesas</li>
                <li>3 gotas amargo de Angostura</li>
              </ul>
              <p className='text-start'>
                <strong>Cristalería:</strong> Copa Huracán.<br />
                <strong>Método:</strong> Directo.<br />
                <strong>Preparación:</strong> Colocar el hielo en un vaso alto. Añadir el jugo de limón, la infusión de frutos rojos en pisco y el puré de frutos rojos. Completar con el Ginger ale, decorar con las frambuesas y finalizar con tres gotas de amargo de Angostura.
              </p>
            </div>
          </div>

          <div className="grid-card">
            <div className="image-wrapper" style={{ "--custom-background": "var(--color-extraordinario)" }} >
              <img src="/image/experiencias/paloma de pisco.webp" alt="Paloma de Pisco" loading="lazy" />
            </div>
            <div className="info-overlay">
              <h3>Paloma de Pisco</h3>
              <div className="info-divider"></div>
              <ul style={{ lineHeight: "1" }}>
                <li>2 oz Pisco Italia</li>
                <li>Agua tónica premium pink</li>
                <li>6 cubos de hielo</li>
                <li>Rodaja de limón</li>
                <li>Zarzamora</li>
              </ul>
              <p className='text-start'>
                <strong>Cristalería:</strong> Vaso highball o copa de vino.<br />
                <strong>Método:</strong> Directo.<br />
                <strong>Preparación:</strong> Servir el pisco sobre el hielo, completar con la tónica pink y decorar con la rodaja de limón y la zarzamora.
              </p>
            </div>
          </div>

          <div className="grid-card">
            <div className="image-wrapper" style={{ "--custom-background": "var(--color-secundario)" }} >
              <img src="/image/experiencias/pisco-sour.webp" alt="Pisco Sour" loading="lazy" />
            </div>
            <div className="info-overlay">
              <h3>Pisco Sour</h3>
              <div className="info-divider"></div>
              <ul style={{ lineHeight: "1" }}>
                <li>3 oz pisco acholado</li>
                <li>1 oz jugo de limón</li>
                <li>1 oz jarabe de goma</li>
                <li>1 dash de clara de huevo</li>
                <li>6 cubos de hielo</li>
                <li>Gotas de amargo de angostura</li>
              </ul>
              <p className='text-start'>
                <strong>Cristalería:</strong> Copa pisco sour o vaso kero.<br />
                <strong>Método:</strong> Batido (Coctelera).<br />
                <strong>Preparación:</strong> Batir enérgicamente todos los ingredientes para generar espuma. Servir en dos tiempos (colado simple) y decorar con gotas de amargo sobre la espuma.
              </p>
            </div>
          </div>

          <div className="grid-card">
            <div className="image-wrapper" style={{ "--custom-background": "var(--color-extraordinario)" }} >
              <img src="/image/experiencias/chilcano-clásico.webp" alt="Chilcano Clásico" loading="lazy" />
            </div>
            <div className="info-overlay">
              <h3>Chilcano Clásico</h3>
              <div className="info-divider"></div>
              <ul style={{ lineHeight: "1" }}>
                <li>2 oz pisco acholado</li>
                <li>Completar con Evervess (Ginger Ale)</li>
                <li>Gotas de amargo de angostura</li>
                <li>6 cubos de hielo</li>
                <li>Rodaja de limón y menta</li>
                <li>Tallo de hierba luisa</li>
              </ul>
              <p className='text-start'>
                <strong>Cristalería:</strong> Vaso highball (largo).<br />
                <strong>Método:</strong> Directo.<br />
                <strong>Preparación:</strong> Llenar el vaso con hielo, verter el pisco, completar con ginger ale fría y añadir el amargo. Mezclar suavemente con el tallo de hierba luisa.
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}
